import { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Layout from './DashboardLayout';
import {
  ProjectSearch,
  ActiveProject,
  ProjectInvitationsModal,
} from '../components/project';
import SwitchView from '../components/SwitchView';
import { fetchInvitations } from '../actions/team';
import { resetProjectsList } from '../actions/projects';

class Project extends Component {
  state = {
    isListView: false,
    invitationsData: {},
  };

  pageHeading = {
    preTitle: 'Projects',
    title: 'Active Projects',
  };

  componentDidMount() {
    const { getInvitations } = this.props;
    getInvitations();
  }

  componentWillUnmount() {
    const { resetProjects } = this.props;
    resetProjects();
  }

  handleChangeView = () => {
    this.setState((state) => ({
      ...state,
      isListView: !state.isListView,
    }));
  };

  render() {
    const { isListView } = this.state;
    const { userData, invitationsData } = this.props;
    return (
      <Layout pageHeading={this.pageHeading}>
        <Row className="mb-4">
          <Col md="6" lg="3">
            <ProjectSearch />
          </Col>
          <Col>
            <SwitchView
              isListView={isListView}
              handleChangeView={this.handleChangeView}
            />
          </Col>
          <Col className="col-auto ml-auto">
            {invitationsData.projects &&
              invitationsData.projects.length > 0 && (
                <ProjectInvitationsModal invitationsData={invitationsData} />
              )}
            {userData.role !== 'member' && (
              <Button
                variant="primary"
                className="lift mb-1 ms-3"
                as={Link}
                to="/projects/create"
              >
                Create Project
              </Button>
            )}
          </Col>
        </Row>
        <Row>
          <ActiveProject isListView={isListView} />
        </Row>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.userReducer,
  invitationsData: state.team.invitationsData,
});
const mapDispatchToProps = () => ({
  getInvitations: fetchInvitations,
  resetProjects: resetProjectsList,
});

Project.propTypes = {
  userData: PropTypes.object,
  getInvitations: PropTypes.func,
  resetProjects: PropTypes.func,
  invitationsData: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps())(Project);
